import { render, staticRenderFns } from "./ResponsiblesSection.vue?vue&type=template&id=64223dbf&"
import script from "./ResponsiblesSection.js?vue&type=script&lang=js&"
export * from "./ResponsiblesSection.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports